import PrivacyPolicy2 from './PrivacyPolicy2'
export default PrivacyPolicy2
